import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-search-ads-identity',
  templateUrl: './help-google-search-ads-identity.component.html'
})
export class HelpGoogleSearchAdsIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
